<template>
    <div class="col-12" id="attachImgSection">
        <draggable
            tag="div"
            class="row"
            :list="addImg"
            v-bind="dragAttcImg"
            @start="isDragging(true)"
            @end="isDragging(false)"
            handle=".moveItem"
            group="sections"
            @change="moveSection"
        >
            <template v-for="(img, idx) in addImg" >
                <div :key="idx" :class="['row_item_image', 'right'==img.align ? 'content-row' : 'content-column']" >
                    <div :class="['content-position', 'right'==img.align ? 'content-position-left' : '']">
                        <div class="custom-control custom-checkbox my-1" >
                            <input type="checkbox" class="custom-control-input" :id="'checkImg-'+idx" v-model="img.isDescription" @change="setUpdate(idx)" />
                            <label class="custom-control-label" :for="'checkImg-'+idx" >Show Description?</label>
                        </div>
                        <div class="btn-group btn-group-sm" role="group" aria-label="align" style="align-items: center;">
                            <span style="margin-left: 50px; margin-right: 10px;">Content position: </span>
                            <button type="button" :disabled="!img.isDescription" :class="['btn btn-outline-dark', img.align == 'right' ? 'active' : '']" @click="changeAlign('right', idx)">Right</button>
                            <button type="button" :disabled="!img.isDescription" :class="['btn btn-outline-dark', img.align == 'below' ? 'active' : '']" @click="changeAlign('below', idx)">Below</button>
                        </div>
                    </div>
                    <div class="content-column-row">
                        <!-- {{ img }} -->
                        <div :class="['sec-imagen', 'right'==img.align ? 'imagen-left' : 'imagen-center', img.isDescription ? 'isDescription' : 'noneDescription']">
                            <div class="input-group mb-3" :style="img.image_name ? 'display:none' : ''">
                                <input type="file" class="form-control" :id="'addImg-'+idx" :ref="'inputAddImg-'+idx" @change="subirImg($event, idx)" accept="image/*" />
                                <label class="input-group-text" for="addImg">Upload</label>
                            </div>
                            <div class="bd-example">
                                <button class="btn btn-danger btn-remove" type="button" :style="!img.image_name ? 'display:none' : ''" @click="imageDeleted(idx)">
                                    <i class="fas fa-trash-alt"></i>
                                </button>
                                <div v-show="img.showLoading" class="loadingImg">
                                    <Loader></Loader>
                                </div>
                                <img :src="img.image ? img.image : imgDefault" class="img-fluid previewImage" alt="Responsive image" @click="openFileDialog(idx)" />
                                <button type="button" class="btn btn-info btn-rotate"
                                    :style="!img.image_name ? 'display:none' : ''"
                                    @click="rotateImage(idx)">
                                    <i class="fas fa-redo"></i>
                                </button>
                            </div>
                        </div>
                        <div :class="['isAttachImg', 'content-align-' + img.align]">
                            <div v-if="img.image==null" @click="requireImg(idx)" class="requireImg"></div>
                            <div class="row">
                                <div class="col-12">
                                    <vue-editor
                                        v-if="img.isDescription"
                                        v-model="img.description"
                                        :editor-toolbar="customToolbar"
                                        class="descripImg"
                                        placeholder="Description about the image"
                                        @text-change="setUpdate(idx)"
                                    />
                                    <!-- <textarea
                                        class="form-control descripImg"
                                        placeholder="Description about the image"
                                        :disabled="!img.isDescription"
                                        v-model="img.description"
                                        @change="setUpdate(idx)"
                                    ></textarea> -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </draggable>
        <div class="row">
            <div class="col-12" v-if="addImg.length > 0 &&  addImg[0].image_name!= null">
                <button type="button" class="btn btn-info" @click="addNewImg" v-if="limitImg>=addImg.length"><i class="fa fa-plus"></i> Add Image</button>

            </div>
        </div>
    </div>
</template>
<script>
import draggable from 'vuedraggable';
import { VueEditor } from 'vue2-editor'
import Loader from '@/core/components/shared/Loader';
import './attachImg.scss';
export default {
    components: {
        Loader,
        VueEditor,
        draggable,
    },
    name: 'attachImg',
    props: {
        propForm: {
            type: Object,
            required: true
        },
    },
    data() {
        return {
            form: this.propForm,
            imgDefault: window.urlmaster + 'images/no-image.png',
            addImg: [{
                image: null,
                rooPath: null,
                image_name: null,
                isDescription: false,
                description: '',
                align: 'below',
                showLoading: false
            }],
            showLoading: [false],
            refreshImg: 0,
            customToolbar: [
                [
                    // { header: [1, 2, 3, 4, 5, 6, false] },
                    "bold",
                    // "italic",
                    "underline",
                    // "strike",
                    { align: "" },
                    { align: "center" },
                    // { align: "right" },
                    // { align: "justify" },
                    // { list: "ordered" },
                    { list: "bullet" },
                    { color: [] },
                    "link",
                    // "image",
                    "clean"
                ]
            ],
            limitImg: 20,
        };
    },
    computed: {
        dragAttcImg() {
            return {
                animation: 200,
                group: "sections",
                disabled: false,
                ghostClass: "ghost",
            };
        },
    },
    mounted() {
        this.showAttchImg();
        // console.log('form', this.form);
    },
    methods: {
        addNewImg() {
            this.addImg.push({
                image: null,
                rooPath: null,
                image_name: null,
                isDescription: false,
                description: '',
                align: 'below',
                showLoading: false,
            });
        },
        showAttchImg() {
            let t = this;
            if(t.form.attcImg.length > 0){
                t.addImg = t.form.attcImg.map((item) => {
                    return {
                        rooPath: item.rooPath,
                        image: window.urlmaster + item.rooPath + item.image_name,
                        image_name: item.image_name,
                        isDescription: item.isDescription,
                        description: item.description,
                        align: item.align || '',
                        showLoading: false
                    };
                });
            }
        },
        openFileDialog(idx) {
            let t = this;
            const ref = document.querySelector('#addImg-' + idx) || this.$refs['inputAddImg-' + idx];
            if (!ref) {
                console.warn('No se encontró el input file para idx:', idx);
                return;
            }
            // Simula un clic en el input file para abrir el diálogo de selección de archivos
            if (ref && typeof ref.click === 'function') {
                ref.click();
            } else {
                console.warn('No se encontró el input file o el ref no es clickeable para idx:', idx);
            }
        },
        requireImg(idx) {
            let t = this;
            t.$swal({
                title: "It is necessary to attach an image.",
                text: "Do you want to upload an image?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Yes",
                cancelButtonText: "Cancel",
            }).then((result) => {
                if (result.value) {
                    t.openFileDialog(idx);
                }
            });
        },
        changeAlign(align, idx) {
            let valueUpdate = this.addImg[idx];
            valueUpdate.align = align;
            this.$set(this.addImg, idx, valueUpdate);
            this.setUpdate(idx);
        },
        setUpdate(idx) {
            let valueUpdate = {};
            valueUpdate.rooPath = this.addImg[idx].rooPath;
            valueUpdate.image = this.addImg[idx].image;
            valueUpdate.image_name = this.addImg[idx].image_name;
            valueUpdate.isDescription = this.addImg[idx].isDescription;
            valueUpdate.description = this.addImg[idx].description;
            valueUpdate.align = this.addImg[idx].align;
            this.saveAttc();
            this.$set(this.form.attcImg, idx, valueUpdate);
            this.$emit('updateAttachImg', {
                'isAttacImg': this.form.isAttacImg,
                'attcImg': this.form.attcImg,
            });
        },
        setUpdateFull() {
            this.form.attcImg = this.addImg;
            this.saveAttc();
            this.$emit('updateAttachImg', {
                'isAttacImg': this.form.isAttacImg,
                'attcImg': this.form.attcImg,
            });
        },
        includeAttachImg() {
            this.form.isAttacImg = !this.form.isAttacImg;
            this.setUpdate();
        },
        subirImg(event, idx) {
            let t = this;
            const file = event.target.files[0];
            if (file) {
                const url = URL.createObjectURL(file);
                this.addImg.image = url;
                this.addImg[idx].showLoading = true;
                var setImage = new FormData();
                setImage.append("user_id", window.master_client);
                setImage.append("org_id", window.localorgdata);
                setImage.append("folder", 'attachImg');
                setImage.append("img1", file, file.name);
                setImage.append("nombreIMG", "img");
                setImage.append("attachImg_id", new Date().getTime().toString());
                setImage.append("contIMG", 1);
                setImage.append("delIMG", "imgOld");
                setImage.append("contDel", 0);
                window.masterGetBilling
                .post("subirIMG", setImage)
                .then(result => {
                    console.log('subirIMG', result.data);
                    let urlImg = t.imgDefault; // imagen x defaul
                    if(result.data.imgs["1"]){
                        urlImg = window.urlmaster + result.data.rooPath.slice(1) + result.data.imgs["1"];
                        this.addImg[idx].rooPath = result.data.rooPath.slice(1);
                        this.addImg[idx].image_name = result.data.imgs["1"];
                        this.addImg[idx].image = urlImg;
                        // Espera un momento para que se vea la imagen
                        setTimeout(() => {
                            this.setUpdateFull();
                        }, 10);
                    }else{
                        t.$notify({
                            group: "noti",
                            type: "error",
                            title: "Error:",
                            text: "Image upload failed, please try again.",
                        });
                    }
                    this.addImg[idx].showLoading = false;
                })
                .catch(err => {
                    this.addImg[idx].showLoading = false;
                    console.log(err);
                });
            }
        },
        rotateImage(idx){
            let t = this;
            this.addImg[idx].showLoading = true;
            console.log('old img', this.addImg[idx].image_name)
            let formData = new FormData();
            formData.append("user_id", window.master_client);
            formData.append("org_id", window.localorgdata);
            formData.append("folder", 'attachImg');
            formData.append("nombreIMG", t.addImg[idx].image_name);
            formData.append("field", "picture");
            formData.append("angle", 90);
            formData.append("pusher_id", pusher.connection.socket_id);
            window.masterGetBilling
            .post('rotate90AnguleImage', formData)
            .then(r => {
                console.log('rotate90AnguleImage', r)
                if(r.data.status){
                    let urlImg = window.urlmaster + r.data.rooPath.slice(1) + r.data.filename;
                    this.addImg[idx].rooPath = r.data.rooPath.slice(1);
                    this.addImg[idx].image_name = r.data.filename;
                    this.addImg[idx].image = urlImg;
                    this.addImg[idx].showLoading = false;
                    console.log('new image', this.addImg[idx].image_name)
                    // this.$set(this.addImg, idx, this.addImg[idx]);
                    // this.refreshImg++;
                    // Espera un momento para que se vea la imagen
                    setTimeout(() => {
                        this.setUpdateFull();
                    }, 10);
                } else {
                    this.addImg[idx].showLoading = false;
                }
            })
            .catch(error => {
                console.log(error);
                this.addImg[idx].showLoading = false;
                t.$notify({
                    group: "noti",
                    type: 'Error',
                    title: "Fail",
                    text: "Failed to save",
                    duration: 2000
                });
            });
        },
        imageDeleted (idx) {
            let t = this;
            t.$swal({
                title: "Remove the image and its related data.",
                text: "You are sure?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Yes, remove it!",
                cancelButtonText: "Cancel",
            }).then((result) => {
                if (result.value) {
                    this.addImg[idx].showLoading = true;
                    var setImage = new FormData();
                    setImage.append("user_id", window.master_client);
                    setImage.append("org_id", window.localorgdata);
                    setImage.append("folder", 'attachImg');
                    setImage.append("image", t.addImg.image_name);
                    window.masterGetBilling
                    .post("delOnlyIMG", setImage)
                    .then(result => {
                        t.addImg[idx].image = t.imgDefault; // imagen x defaul;
                        if(!result.data.status){
                            if(t.addImg.length > 1){
                                t.addImg.splice(idx, 1); // Elimina el elemento del array
                                console.log('sacar del arreglo', this.addImg)
                            }else{
                                t.addImg[idx].image_name = null;
                                t.addImg[idx].rooPath = null;
                                t.addImg[idx].isDescription = false;
                                t.addImg[idx].description = '';
                                t.addImg[idx].align = 'below';
                                console.log('reiniciar valores', this.addImg)
                                this.addImg[idx].showLoading = false;
                            }
                            console.log('delOnlyIMG', result.data)
                            setTimeout(() => {
                                this.setUpdateFull();
                            }, 10);
                        }else{
                            t.$notify({
                                group: "noti",
                                type: "error",
                                title: "Error:",
                                text: "Image upload failed, please try again.",
                            });
                        }
                    })
                    .catch(err => {
                        if(this.addImg[idx]){
                            this.addImg[idx].showLoading = false;
                        }
                        console.log(err);
                    });
                }
            });
        },
        isDragging(t) {
            console.log('move', t) // t = true or false
            return t;
        },
        log: function (evt) {
            console.log('log', evt)
        },
        addItem: function (evt) {
            console.log('addItem', evt);
        },
        moveSection(){
            let t = this;
            // let list = [];
            // t.f.actions.forEach((element, idx) => {
            //     list.push(element);
            //     list[idx].item_order = idx;
            // });
            // console.log('moveSection', list)
            // t.f.actions = list;
            // let url = 'orderActionsTaskKnow';
			// window.billing
            // .put(url, t.f)
            // .then((response) => {
            //     console.log(url, response.data);
            // })
            // .catch((error) => {
            //     console.log(error);
			// 	t.isLoading=false;
            // });
        },
        saveAttc(){
            // window.billing
            window.billingSales.post('estimate/editAttcImg', {
                estimate_id: this.form.idEst,
                attcImg: JSON.stringify(this.form.attcImg),
            })
            .then((response) => {
                console.log('saveAttcImg', response.data);
            })
        }
    },
};
</script>
<style scoped>

</style>
